import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=75c472b0&scoped=true&"
import script from "./ModalConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=75c472b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c472b0",
  null
  
)

export default component.exports